export default defineNuxtPlugin({
  name: 'showGoogleAuthError',
  setup() {
    const { checkGoogleAuthError } = useGoogleRedirect()

    checkGoogleAuthError()
  },
})
